module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_iterators.js
// module id = 42
// module chunks = 1 2 3 4 5 6 7 8 9